import { render, staticRenderFns } from "./FrameChooser.vue?vue&type=template&id=e00a76ec&"
import script from "./FrameChooser.vue?vue&type=script&lang=ts&"
export * from "./FrameChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports